// Utility for safely merging RRULE objects coming from FullCalendar event instances.
//
// FullCalendar can provide an RRULE object for a *single dragged instance* of a recurring event.
// In some cases it drops parts of the original rule (notably `until`).
// We treat the RRULE stored in our context/state as canonical and merge in instance changes,
// while preserving `until` from the stored rule when present.

export type RRuleLike = Record<string, any> | undefined | null

export function mergeRRulePreserveUntil(
	storedRRule: RRuleLike,
	incomingRRule: RRuleLike
): RRuleLike {
	if (!storedRRule) return incomingRRule || undefined

	const merged = {
		...(storedRRule || {}),
		...(incomingRRule || {}),
	}

	// Preserve stored UNTIL if it existed, regardless of what the incoming instance provides.
	if (storedRRule && (storedRRule as any).until) {
		;(merged as any).until = (storedRRule as any).until
	}

	return merged
}
